import { useEffect, useRef } from 'react';

// The document <title> per view — the tab, history entries and a screen reader's page
// announcement name what's open, not just the workspace. The app's base title ("Acme ·
// Support", App.jsx applyAccountChrome → setBaseTitle) sits under a stack of view titles: a
// view that calls useDocumentTitle shows "{its title} · {base}" while it's mounted (the ticket
// subject while a ticket is open, "Knowledge base" on /kb/), and unmounting restores whatever
// is under it — the queue's own title, or the base.
let base = null;
const views = [];

function paint() {
  if (typeof document === 'undefined') return;
  if (base === null) base = document.title; // index.html's, until /api/me names the workspace
  const top = views.length ? views[views.length - 1].title : '';
  document.title = top ? `${top} · ${base}` : base;
}

export function setBaseTitle(title) {
  base = title;
  paint();
}

// `title`: plain text, or empty / null for "nothing to add" (e.g. still loading).
export function useDocumentTitle(title) {
  const entry = useRef(null);
  useEffect(() => {
    const e = { title: '' };
    entry.current = e;
    views.push(e);
    return () => {
      const i = views.indexOf(e);
      if (i >= 0) views.splice(i, 1);
      paint();
    };
  }, []);
  useEffect(() => {
    entry.current.title = String(title || '').replace(/\s+/g, ' ').trim();
    paint();
  }, [title]);
}
